import { LoadBuildingHandledReason } from './types';

export const BUILT_GROUP_LABEL = 'Built';

// Shown from the Built group's help button.
export const BUILT_GROUP_EXPLANATION =
  'Drumkit found these loads already built in Drumkit or in your TMS. Click a load ID to open it.';

// Headline of a built row's tooltip. It says how Drumkit knows the load exists.
export const BUILT_REASON_LABELS: Record<LoadBuildingHandledReason, string> = {
  [LoadBuildingHandledReason.DrumkitBuild]: 'Built in Drumkit',
  [LoadBuildingHandledReason.TmsMatch]: 'Found in TMS',
};

// Kit's bubble copy when every load building card on the thread is built.
export const ALL_BUILT_MESSAGE = 'All loads on this thread are built';
